export enum InterviewType{
   
    HrInterview = 'HR Interview',
    Masters='Masters',
}